import React from 'react';
import { m } from 'framer-motion';
import { CreditCardIcon, ZapIcon, ShieldCheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
const trustItems = [{
  icon: CreditCardIcon,
  label: 'Pago único'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}];
export function PriceReveal() {
  return <section id="oferta" className="bg-cream-dark py-10 sm:py-14" data-id="element-105" data-mp="vfy8t93etqk1">
      <div className="mx-auto max-w-xl px-4 text-center sm:px-6" data-id="element-106" data-mp="vhsuwqqf3opp">
        <p className="font-heading text-lg font-semibold text-navy sm:text-xl" data-id="element-107" data-mp="10drfe38mkmku">
          Hoy, el sistema completo cuesta:
        </p>

        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45
      }} className="mt-6 rounded-3xl border border-orange/40 bg-white p-6 shadow-card sm:p-8" data-id="element-108" data-mp="lnsgtzd5r94u">
          <p className="text-sm text-muted" data-id="element-109" data-mp="1j6lhhwl5gk7n">
            Valor real: <span className="line-through" data-id="element-110" data-mp="u38fr6g5jnu6">240€</span>
          </p>
          <p className="mt-1 font-heading text-6xl font-extrabold text-orange-hover sm:text-7xl" data-id="element-111" data-mp="p4x54ti199aw">19€</p>
          <p className="mt-3 text-sm leading-relaxed text-ink sm:text-base" data-id="element-112" data-mp="12wbpp4rl9ik2">
            Acceso inmediato a todos los tomos y bonos. De por vida.
          </p>

          <div className="mt-6" data-id="element-113" data-mp="y425m5d5ncpp">
            <PrimaryButton fullWidth size="lg" data-id="element-114" data-mp="1cuj3xfuhtmid">
              Acceso Ahora — 19€
            </PrimaryButton>
          </div>

          <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-muted" data-id="element-115" data-mp="17vy4vjqz98vi">
            {trustItems.map(item => <span key={item.label} className="flex items-center gap-1" data-id="element-116" data-mp="1luei7tjchxmm">
                <item.icon size={12} data-id="element-117" data-mp="1huxd517tz2hz" /> {item.label}
              </span>)}
          </div>
        </m.div>
      </div>
    </section>;
}